import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Building2, CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Register() {
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async () => {
    setBusy(true); setErr("");
    try { await axios.post(`${API}/auth/register-landlord`, f); setDone(true); }
    catch (e) { setBusy(false); setErr(e.response?.data?.detail || "Registration failed. Please try again."); }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-6"><div className="h-9 w-9 rounded-md bg-[#18181A] flex items-center justify-center"><Building2 className="h-5 w-5 text-white" /></div><span className="font-head text-xl font-extrabold tracking-tight">Owner registration</span></div>
        {done ? (
          <div className="bg-white border border-border rounded-md p-8 text-center" data-testid="register-done">
            <CheckCircle2 className="h-10 w-10 text-[#2B4C3F] mx-auto mb-3" />
            <h1 className="font-head text-2xl font-extrabold">Thanks — you're in the queue</h1>
            <p className="text-sm text-muted-foreground mt-2">Your account is awaiting approval by our team. We'll be in touch once it's active.</p>
            <Link to="/login" className="text-sm underline mt-4 inline-block">Back to sign in</Link>
          </div>
        ) : (
          <div className="bg-white border border-border rounded-md p-6">
            <p className="text-sm text-muted-foreground mb-5">Register to manage your properties. An admin will approve your account before you can sign in.</p>
            <div className="space-y-3">
              <div><Label className="overline">Full name</Label><Input data-testid="reg-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="mt-1.5" /></div>
              <div><Label className="overline">Email</Label><Input data-testid="reg-email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="mt-1.5" /></div>
              <div><Label className="overline">Phone (optional)</Label><Input data-testid="reg-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="mt-1.5" /></div>
              <div><Label className="overline">Password</Label><Input data-testid="reg-password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="mt-1.5" /></div>
              {err && <p data-testid="reg-error" className="text-xs text-[#9E382A]">{err}</p>}
              <Button className="w-full" data-testid="reg-submit" disabled={busy || !f.name || !f.email || !f.password} onClick={submit}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Register"}</Button>
              <p className="text-center text-sm text-muted-foreground">Already have an account? <Link to="/login" className="underline">Sign in</Link></p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
